import SortPopup, { SortOption } from "../../../components/sort_popup/sort_popup";

export type LandingPageSortOption = "newest" | "oldest" | "nameAsc" | "nameDesc";

export const DEFAULT_LANDING_PAGE_SORT_OPTION: LandingPageSortOption = "newest";

const OPTIONS: SortOption<LandingPageSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function landingPageSortOptionLabel(option: LandingPageSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function landingPageSortOptionToParams(option: LandingPageSortOption): {
  sortBy: "createdAt" | "content_name";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "createdAt", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "createdAt", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "content_name", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "content_name", sortOrder: "DESC" };
  }
}

export default function SortLandingPagePopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: LandingPageSortOption;
  setSortOption: (option: LandingPageSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Content Pages"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
